import './scss/styles.scss';
import error from './assets/img/error.png';
import icon_menu from './assets/img/icon_menu.svg';
import icon_cierre_minas from './assets/img/cierre-minas.png';
import icon_descarbonizacion from './assets/img/descarbonizacion.png';
import icon_economia_circular from './assets/img/economia-circular.png';
import icon_gestion_hidrica from './assets/img/gestion-hidrica.png';
import icon_industria from './assets/img/industria.png';
import icon_relaciones from './assets/img/relaciones.png';
import icon_seguridad from './assets/img/seguridad.png';
import fondo_landing from './assets/img/imagen-landing.jpg';
import fondo_landing_form from './assets/img/imagen-landing-form.jpg';
import fondo_landing_post from './assets/img/landing-post.jpg';
import logo_anglo_blanco from './assets/img/logo-anglo-blanco.png';
import logo_anglo_cafe from './assets/img/logo-anglo-cafe.png';
import logo_anglo_footer from './assets/img/logo-anglo-gold-cafe-footer.png';
import logo_cobre_footer from './assets/img/logo-cobre-footer.png';
import logo_quebra_dona_footer from './assets/img/logo-quebra-dona-footer.png';
import {menuToggle} from './js/nav';

menuToggle()

